import { createFormatService } from './FormatService.impl';

/**
 * Singleton format service instance
 * This is injected into components via props using WithServices<[WithFormatService]>
 */
export const myFormatService = createFormatService();
